const newQuoteDataInputs = {
  model: "quote",
  currentIndex: 0,
  steps: [
    {
      index: 0,
      valid: false,
      inputs: [
        {
          label: "Quel type de vélo possédez-vous ?",
          type: "radioButtons",
          name: "kind",
          valid: false,
          buttons: [
            {
              img: {
                url: "https://res.cloudinary.com/new-app/image/upload/v1624540643/vae-profile-43.png",
                alt: "vélo électrique",
              },
              label: "Vélo électrique",
              value: "electric",
            },
            {
              img: {
                url: "https://res.cloudinary.com/new-app/image/upload/v1624540238/velo-route-profile-43.png",
                alt: "vélo classique",
              },
              label: "Vélo classique",
              value: "electric_not",
            },
          ],
        },
      ],
    },
    {
      index: 1,
      valid: false,
      inputs: [
        {
          label: "Pour quels types de déplacements ?",
          type: "radioButtons",
          name: "usage",
          valid: false,
          buttons: [
            {
              label: "Particuliers",
              value: "particular",
            },
            {
              label: "Professionnels et Particuliers",
              value: "professional",
            },
          ],
        },
      ],
    },
    {
      index: 2,
      valid: false,
      inputs: [
        {
          label: "Pour quelle pratique principale ?",
          type: "radioButtons",
          name: "practice",
          valid: false,
          buttons: [
            {
              label: "Vélo de route",
              value: "road",
            },
            {
              label: "Vélo tout terrain",
              value: "vtt",
            },
            {
              label: "Vélo urbain",
              value: "urban",
            },
          ],
        },
      ],
    },
    {
      index: 3,
      valid: false,
      inputs: [
        {
          label: "Le vélo est il un achat personnel ou une location ?",
          type: "radioButtons",
          name: "property",
          valid: false,
          buttons: [
            {
              label: "C'est mon propre vélo",
              value: "own",
            },
            {
              label: "C'est un vélo de leasing",
              value: "leasing",
            },
            {
              label: "C'est un vélo en location longue durée",
              value: "long_term_rental",
            },
          ],
        },
      ],
    },
    {
      index: 4,
      valid: false,
      inputs: [
        {
          label: "Date d'achat de votre vélo ?",
        },
      ],
    },
    {
      index: 5,
      valid: false,
      label: "Informations relatives au vélo",
      inputs: [
        {
          index: 0,
          type: "text",
          kind: "text",
          label: "Marque",
          field: "label",
          errorMessage: "La marque de votre vélo doit être presente",
          valid: false,
        },
        {
          index: 1,
          type: "text",
          kind: "text",
          label: "Modèle",
          field: "model",
          errorMessage: "Le modèle de votre vélo doit être present",
          valid: false,
        },
        {
          index: 2,
          type: "number",
          kind: "number",
          label: "Prix d'achat",
          field: "price",
          errorMessage: "Le prix de votre vélo in invalide",
          valid: false,
        },
      ],
    },
    {
      index: 6,
      valid: false,
      inputs: [
        {
          label: "Vous êtes ?",
          type: "radioButtons",
          name: "title",
          valid: false,
          buttons: [
            {
              label: "Homme",
              value: "male",
            },
            {
              label: "Femme",
              value: "female",
            },
          ],
        },
      ],
    },
    {
      index: 7,
      valid: false,
      label: "Informations relatives à l'assuré",
      inputs: [
        {
          index: 0,
          type: "text",
          kind: "name",
          label: "Prénom",
          field: "first_name",
          errorMessage: "Le prénom doit être renseigné",
          valid: false,
        },
        {
          index: 1,
          type: "text",
          kind: "name",
          label: "Nom",
          field: "last_name",
          errorMessage: "Le nom doit être renseigné",
          valid: false,
        },
        {
          index: 2,
          type: "email",
          kind: "email",
          label: "Email",
          field: "email",
          errorMessage:
            "L'email doit être renseigné au format example@domaine.com",
          valid: false,
        },
        {
          index: 3,
          type: "text",
          kind: "phone",
          label: "Téléphone portable",
          field: "phone",
          errorMessage: "Le téléphone portable doit être présent",
          valid: false,
        },
        {
          index: 4,
          type: "text",
          kind: "address",
          label: "Rue / Lieu dit",
          field: "address",
          errorMessage:
            "La rue ou le lieu dit doit être présente. Les carractères spéciaux ne sont pas acceptés.",
          valid: false,
        },
        {
          index: 5,
          type: "text",
          kind: "zipCode",
          label: "Code postal",
          field: "zip_code",
          errorMessage: "Le code postal n'est pas valide",
          valid: false,
        },
        {
          index: 6,
          type: "text",
          kind: "text",
          label: "Ville",
          field: "city",
          errorMessage: "La ville doit être présente",
          valid: false,
        },
      ],
    },
  ],
};

export default newQuoteDataInputs;
